import {of} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as ChildObservables from 'web-app/react/entities/children/epics';
import * as ContactActions from 'web-app/react/entities/contacts/actions';
import {relationsFromChildren} from 'web-app/react/invite-parents/helpers';

import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetchChildren.type).mergeMap(({payload}) =>
        ChildObservables.fetchChildrenObservable(
            payload.institutionId,
            payload.embedRelations,
            payload.includeFuture,
            payload.includePast,
            true,
        )
            .flatMap(childAction => [
                childAction,
                Actions.fetchChildrenSuccess.action(childAction.payload.children),
                ContactActions.addContacts.action(relationsFromChildren(childAction.payload.children)),
            ])
            .catch(e => of(Actions.fetchChildrenFailed.action(e))),
    );

export default combineEpics(fetch);
